export const APIS = {
  DASHBOARD: {
    GETCONFIG: "dashboard/getDashboardConfig/Thor/home",
    GETCHART: "dashboard/getChartV2/Thor",
  },
  DASHBOARDTWO: {
    GETCONFIG: "dashboard/getDashboardConfig/Pulz/home",
    GETCHART: "dashboard/getChartV2/Pulz",
  },
  PROFILE: {
    GETPROFILE:
      "dashboard/getDashboardsForProfile" + process.env.REACT_APP_GET_PROFILE,
  },
  MULTIPLEDASHBOARD: {
    GETCONFIG:
      "dashboard/getDashboardConfig" + process.env.REACT_APP_GET_CONFIG + "/",
    GETCHART: "dashboard/getChartV2" + process.env.REACT_APP_GET_CHART,
  },
  LOGIN: {
    USERLOGIN: "login",
  },
  FORM: {
    GET: "forms/getAllForms",
    FIND: "forms/getFormById?id=",
    ADD: "forms/createForm",
    UPDATE: "",
    DELETE: "",
    SUBMIT: "forms/saveFormSubmit",
    UPLOAD_FILE:"forms/uploadData"
  },
};
